import { createGlobalStyle } from 'styled-components';
import { BAR_SHADOW, WHITE } from './constants';

const GlobalStyle = createGlobalStyle`
    html {
        background: #fff !important;
        height: 100%;
    }

    body {
        font-family: 'Raleway';
        background-color: #fff;
        height: 100%;

            > div {
                @media (max-width: 800px) {
                    height: 100%;

                    > div {
                        height: 100%;

                        > div {
                            height: 100%;
                        }
                    }
                }
            }
        }
    }

    section[role="dialog"][aria-describedby^="modal-content"] {
        padding: 3.5625rem 4.0625rem;

        div[id^="modal-content"] {
            padding: 0;

            div[class*="IconContainer"]:empty {
                margin: 0;
            }
        }

        & > button[data-id="button-icon-element"] {
            display: flex;
            width: 2rem;
            height: 2rem;
            padding: 0.5rem !important;
            justify-content: center;
            align-items: center;
            flex-shrink: 0;
            top: -0.7rem;
            right: -0.7rem;
            background: ${WHITE};
            border-radius: 0.375rem;
            box-shadow: ${BAR_SHADOW};
        }
        
        & > header {
            padding: 0;
        }

        & > footer {
            border: none;
            padding: 1.5rem 0rem 0rem 1.5rem;
            & > div {
                display: flex;
                justify-content: flex-end;
                align-content: center;
                gap: 1rem;
            }
            button {
                border-radius: 0.375rem;
                margin: 0;
            }
        }
    }
`;

export default GlobalStyle;
